import { render, staticRenderFns } from "./StudentExchangeProgressColumnWidget.vue?vue&type=template&id=07834eb2&"
import script from "./StudentExchangeProgressColumnWidget.vue?vue&type=script&lang=ts&"
export * from "./StudentExchangeProgressColumnWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports